import { useContext } from "react"
import { LiteralsContext } from "../contexts/LiteralsContext"

export const useLiterals = () => {
    return useContext(LiteralsContext);
}